// Resource definition for React Admin
export const feeTemplateChangesResource = {
  name: '排程費用變更',
  fields: {
    id: 'ID',
    templateId: '範本',
    template: '範本',
    effectiveDate: '生效日期',
    status: '狀態',
    changes: '變更',
    reason: '原因',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    newStructure: '新結構',
    appliedAt: '套用時間',
    appliedBy: '套用者',
    createdBy: '建立者',
    component: '組件',
    configuration: '配置',
  },
};

// Custom fee template changes translations
export const feeTemplateChanges = {
  name: '排程費用變更',
  fields: {
    id: 'ID',
    templateId: '範本',
    template: '範本',
    effectiveDate: '生效日期',
    status: '狀態',
    changes: '變更',
    reason: '原因',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    newStructure: '新結構',
    appliedAt: '套用時間',
    appliedBy: '套用者',
    createdBy: '建立者',
    component: '組件',
    configuration: '配置',
    actions: '操作',
  },
  status: {
    pending: '待處理',
    applied: '已套用',
    cancelled: '已取消',
    overdue: '已逾期',
    failed: '失敗',
  },
  empty: {
    title: '無排程變更',
    subtitle: '目前沒有排程的費用範本變更',
  },
  list: {
    title: '排程費用變更',
    filters: {
      search: '搜尋',
      status: '狀態',
      template: '範本',
      effectiveFrom: '生效起始',
      effectiveTo: '生效結束',
    },
  },
  notifications: {
    cancelled: '費用範本變更取消成功',
    cancelFailed: '費用範本變更取消失敗',
    applied: '費用範本變更套用成功',
    applyFailed: '費用範本變更套用失敗',
    created: '費用範本變更排程成功',
    updated: '費用範本變更更新成功',
    deleted: '費用範本變更刪除成功',
  },
  actions: {
    cancel: '取消',
    apply: '立即套用',
    schedule: '排程變更',
    cancelTitle: '取消排程變更',
    cancelConfirm: '您確定要取消此排程變更嗎？此操作無法復原。',
    confirmCancel: '是的，取消變更',
  },
  show: {
    title: '費用範本變更詳情',
    subtitle: '查看排程的費用範本變更資訊',
    basicInfo: '基本資訊',
    changeDetails: '排程變更',
    changeDetailsApplied: '已套用變更',
    noChangesDetected: '目前結構與新結構之間未檢測到變更',
    appliedAt: '此變更已於 {date} 套用',
    cancelled: '此排程變更已被取消',
  },
};